// Shared by React and the Node build step; CMS HTML is never rewritten here.
const SITE_URL = 'https://aisearchadvisers.com';
const TARGET_SLUG = 'ai-search-for-small-business';
const defaults = require('../data/blogSeo.json');
function absoluteUrl(value) {
  if (!value) return undefined;
  try { const url = new URL(value, SITE_URL); return /^https?:$/.test(url.protocol) ? url.href : undefined; } catch { return undefined; }
}
function blogUrl(post) {
  return absoluteUrl(post.canonicalUrl || defaults.posts[post.slug]?.canonicalUrl) || `${SITE_URL}/blogs/${encodeURIComponent(post.slug)}`;
}
function blogSeo(post) {
  const data = { ...defaults.posts[post.slug], ...Object.fromEntries(Object.entries(post).filter(([, v]) => v !== null && v !== '')) };
  const title = data.seoTitle || post.page_title || post.title;
  const description = data.metaDescription || post.meta_description || post.excerpt || '';
  const canonical = blogUrl(post);
  const image = absoluteUrl(data.socialImage);
  const author = { '@type': 'Person', name: data.authorName || post.author_name || post.author?.name || 'AI Search Advisers' };
  const authorUrl = absoluteUrl(data.authorUrl);
  if (authorUrl) author.url = authorUrl;
  const sameAs = (data.authorSameAs || []).map(absoluteUrl).filter(Boolean);
  if (sameAs.length) author.sameAs = sameAs;
  const publisher = { '@type': 'Organization', name: 'AI Search Advisers', url: `${SITE_URL}/` };
  const logo = absoluteUrl(defaults.publisherLogo);
  if (logo) publisher.logo = { '@type': 'ImageObject', url: logo };
  const article = { '@context': 'https://schema.org', '@type': 'BlogPosting', headline: post.title, description,
    mainEntityOfPage: { '@type': 'WebPage', '@id': canonical }, author, publisher };
  if (image) article.image = image;
  for (const [key, value] of Object.entries({ datePublished: data.datePublished || post.published_at, dateModified: data.dateModified || post.updated_at || post.published_at })) {
    if (value && !Number.isNaN(Date.parse(value))) article[key] = value;
  }
  const breadcrumb = { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement:
    [['Home', `${SITE_URL}/`], ['The AI Search Return Blog', `${SITE_URL}/blogs`], [post.category_name || 'General', canonical]]
      .map(([name, item], i) => ({ '@type': 'ListItem', position: i + 1, name, item })) };
  return { title, description, canonical, image, ogType: 'article', schema: [article, breadcrumb] };
}
module.exports = { SITE_URL, TARGET_SLUG, absoluteUrl, blogUrl, blogSeo };
